import hljs from 'highlight.js'
import { type Tokens, marked } from 'marked'
import { markedHighlight } from 'marked-highlight'

const linkRenderer = new marked.Renderer()
linkRenderer.link = (link: Tokens.Link) => {
  const { title, href, text } = link
  const safeHref = href ?? '#'
  const displayText = text || link || ''
  const titleAttr = title ? `title="${title}"` : ''
  return `<a href="${safeHref}" target="_blank" rel="noopener noreferrer" ${titleAttr}>${displayText}</a>`
}

linkRenderer.html = (token: Tokens.HTML | Tokens.Tag) => {
  return token.text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

marked.setOptions({
  gfm: true,
  breaks: true,
  renderer: linkRenderer,
})
marked.use(
  markedHighlight({
    emptyLangClass: 'hljs',
    langPrefix: 'hljs language-',
    highlight(code: string, lang: string) {
      const language = hljs.getLanguage(lang) ? lang : 'plaintext'
      return hljs.highlight(code, { language }).value
    },
  }),
  {
    extensions: [
      {
        name: 'usernameHighlight',
        level: 'inline',
        start(src) {
          return src.match(/@[a-zA-Z0-9_]+/)?.index
        },
        tokenizer(src) {
          const rule = /^(@[a-zA-Z0-9_]+)/
          const match = rule.exec(src)
          if (match) {
            return {
              type: 'usernameHighlight',
              raw: match[0],
              username: match[1],
            }
          }
          return
        },
        renderer(token) {
          return `<span class="font-extrabold">${token.username}</span>`
        },
      },
    ],
  },
)

export const markdownConverter = marked

export const capitalizeFirstLetter = (value: string) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()

export const highlightUsername = (value: string) => {
  const regex = /(?:^@|(?<=\s)@)([a-z0-9_]+)/g
  return value.replaceAll(regex, (_, username) => `<span class="font-extrabold">@${username}</span>`)
}

export const identifyUsername = (value: string) => {
  const regex = /\*\*@([a-z0-9_]+)\*\*/g
  return value.replaceAll(regex, (_, username) => `@${username}`)
}

export const escapeForWAF = (value: string): string => {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;')
}

export const unescapeForWAF = (value: string): string => {
  return value
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&')
}
